.bg {
  background: black;
  display: grid;
  height: 100vh;
  height: 100dvh;
  opacity: 0.5;
  place-items: center;
  width: 100vw;
}
